var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3113_931",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3113_931",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADQUlEQVR4nO2dO24UQRCGC18ALsBrd7vWASJBJCQ8IsQZDJG1VUNCgGULIbEIYeAEcAAfwOIEkGBfwHKGBKQgkAggMdtoekBisfeBdqarh/5/qaLd4O/6prurt3e6iSAIgiAIgiAIgiAIgiAoN7miQ05ukZM14mIji3BlW/Um8epZSkas14hll1h95rFD/eKqIYnhEjl5mkAifEIxIpbNkJvoAgw/GUwJJfowVT4N5k+kTzRGcYcvzBl+Dig7cWD05UwCT6BvR8SovsrS1ryh2pIoVpoHEmpw64ZqS6LYaB6Ik4f2DdV2RJkrAFF7EACi9skHELVPOICofZIBRO0TCyBqn0wASSCBALLIcKCvwo+cy8WFsaj2Z16n4TGbdYh8o87g+ESPp++cINbv5j4zArI/02f5HWufGQHZmwPInrlPAPlDAIIeQhn3kLczfZbfsfaZEZAfocSdCKO4mMSef2brkK/k5PnhP6/pi/CZtb/sgHALAkDUHgKAqH3iAUTtkw0gap9gAFH7pAKI2icSQBZNgnyoIgEIWZe9TrbDm1u/1Rt0yclLc19ZAnGyTUTHJrxIlAaUjICMxnrG3+re7iXgMSsg72f6TGFOyQeIYMcQQBQ9hNBDMGQR5hDMIYsJk7pHlcWostBDGOsQj3UI5hCPlTpW6jULVZZHlcWostBDGFWWR5WFOcSjyqqnytqf+SzhlbaoO3Gfpx80OVwili/mG2n57BiqJx5cn+Lxhr2/3IA4eUfd4uQhf53BqbDnbu0vOyAcXtr5SE7uUb+4FMLJfXLyydxXtkA48QAQtYcAIGqfeABR+2QDiNonGEDUPqkAovaJBJAEksdtBYKjxv38UGS9eSA4jN+ndRg/rqvw8wOJdVlYeVmJ9fjMiYeTNxRN5XU+KRx/xMnGiHrFZYoq1icJNNwnGU4eUXyFXblN9BQd7xmsj49+OziW+nIFc4pWc0b0YWqayoqiLPOqK0mf1RRbDQwnW7X5q06xWwmVZzZiWa8PiDywbs7/Ia4DCmCkdDvcsGY30AJQACMhKMNmzUD/AgUwosrJGrEeHAHigJzejWsGqsTF+XCSdbi9WnbDSdfLeu7XpxAEQRBEOekni50ozsmtMdcAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.efdc86f93abdc0f285d003def147319c.svg";
export { ForwardRef as ReactComponent };